  $('body').on('click','.cart_freebie_pdp_btns button',function(){
    $('.cart_freebie_pdp_btns button').attr('disabled','disabled');
 if($(this).hasClass('soldout_btn')){
 alert('This product is not available');
    $('.cart_freebie_pdp_btns button').removeAttr('disabled');
  return false; 
 }
    
    var count = 0;
    var _this = this;
     $('.cart_freebie_pdp_inner').each(function(index){
       if($(this).hasClass('already_added_in_cart')){
         if(!$(_this).hasClass('remove')){
           count++;
         }
       }
       }).promise().done(function(){
       if(count > 0){
         alert('Sorry !! You can select 1 items only.');
          $('.cart_freebie_pdp_btns button').removeAttr('disabled');
         return false;
       }
    var id = $(_this).attr('id');
     var data = { updates: {} };
    if($(_this).hasClass('remove')){
      data.updates[id] = 0;
    }else{
      data.updates[id] = 1;
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      async: false,
      dataType: 'json',
      success: function() {
      CartDrawerUpdate();
      },
      error:function(){
       CartDrawerUpdate();
      }
    }); 
       });
    })

  

  function CartDrawerUpdate(){
  fetch(`/cart?section_id=cart-drawer`)
  .then((response) => response.text())
  .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const sourceQty = html.querySelector('.cart-drawer').innerHTML;
    $('.cart-drawer').html(sourceQty); 
    var cart_count = parseInt($('.drawer__header').attr('cart-count'));
    $('.cart-count-bubble span').eq(0).text(cart_count);
     $('.cart_freebie_pdp_btns button').removeAttr('disabled');
  })
  .catch((e) => {
    console.error(e);
     $('.cart_freebie_pdp_btns button').removeAttr('disabled');
  });
}